import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = not auth, object = auth

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => setAdmin(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAdmin(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, setAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
